export default "__VITE_ASSET__C8R6g1Di__"